(function ($) {
  'use strict';

  this.TDF2025 = function () {};
}).bind(window)(jQuery);
